var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElDoubleOutServiceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H12C13.1046 0 14 0.895431 14 2V4C14 5.10457 13.1046 6 12 6H8V0Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 8.89543 0.895431 8 2 8H6V14H2C0.89543 14 0 13.1046 0 12V10Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H12C13.1046 8 14 8.89543 14 10V12C14 13.1046 13.1046 14 12 14H8V8Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H6V6H2C0.89543 6 0 5.10457 0 4V2Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElDoubleOutServiceDark);
export default __webpack_public_path__ + "static/media/el-double-out-service-dark.707ac36900411b02f5630ff8502edc66.svg";
export { ForwardRef as ReactComponent };